<template>
	<div class="newsandinformation">
		<div class="g-s-a-w">
			<img class="news_image" v-lazy="img" />
		</div>
		<div class="introduction container_full po_r m_a">
			<div class="about_us">
				<div>
					<p style="padding-bottom: 20px;">法律声明</p>
				</div>
				<ul class="active">
					<li class="active">
						<!-- <p class="item">
              <span class="span_css">公司介绍</span>
              <i class="el-icon-arrow-right"></i>
            </p> -->
						<div class="info">
							<span class="info_active" @click="tiaoyemain('privacy')">隐私政策</span>
							
							<div class="info1">
								<span class="info_active" style="color: #FFFFFF;">法律声明</span>
							</div>
							
						</div>
					</li>
				</ul>
			</div>
			<div class="com_profile com_profile_active">
				<div class="detail">
					<div style="width: 860px;height:800px;">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="法律声明" name="first">

								<ol class="list_text">
									<li class="lili">
										使用本网站前，请您仔细阅读下述条款。如您不同意本服务条款或本网站对其进行的修改，您可以主动取消本网站提供的服务；您一旦使用本网站提供的服务，即视为您已了解并完全同意本服务条款各项内容，包括本网站对服务条款所做的任何修改，并成为本网站的用户（以下简称“用户”）。
									</li>
								</ol>
								<br />
								<ol class="list_text3">
									<p class="qiang_font_p">版权归属</p>
									<li class="li_css">
										中国邮政速递物流股份有限公司独立拥有本网站相关网页内所有资料的版权，或与本网站相关网页内的资料提供者共同拥有该网页内资料的版权。未经中国邮政速递物流股份有限公司的明确书面许可，对于本网站上的任何内容，任何人不得对其进行复制或在非中国邮政速递物流股份有限公司所属的服务器上转载。
									</li>
								</ol>
								<br />
								<ol class="list_text2">
									<p class="qiang_font_p">免责声明</p>
									<li class="lililon">
										（1）本网站所发布的信息中可能没有包含与中国邮政速递物流股份有限公司及其业务有关的最新信息，对于本网站所发布的信息，本公司不声明或保证其内容之正确性或完整性；对于用户通过本网站有关服务之广告、信息而购买或取得之任何产品、信息或服务，本公司亦不承担质量保证之责任。
									</li>

									<li class="lililon">
										（2）中国邮政速递物流股份有限公司对本网站提供的服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证。
									</li>

									<li class="lililon">
										（3）用户明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其他无形损失，中国邮政速递物流股份有限公司不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任（即使中国邮政速递物流股份有限公司事先已被告知发生此种赔偿之可能性亦然）：
									</li>

									<li class="lililon">
										<ol class="qiang_font1">
											<li>1、本网站提供服务之使用或无法使用；</li>
											<li>2、为替换通过本网站服务购买或取得之任何商品、数据、信息、服务，或缔结的交易而发生的成本；</li>
											<li>3、您的传输或数据遭到未获授权的存取或篡改；</li>
											<li>4、任何第三方在本服务中所作之声明或行为；</li>
											<li>5、与本服务相关的其他事宜，但本服务条款有明确规定的除外。</li>
										</ol>
									</li>

									<li class="lililon">
										（4）本网站转载的相关文章、资料中表述或暗示的观点不代表中国邮政速递物流股份有限公司的观点。
									</li>

									<li class="lililon">
										（5）本网站所提供的信息，若在某地区使用或发布时会违反该地区的法律或规定，则不得在该地区使用或发布本网站信息。
									</li>
									<li class="lililon">
										（6）本网站遵循互利互惠的原则进行内容合作。所转载的信息都已经过版权所有者的口头或书面的许可，如有遗漏，请与我们联系并提供相应的证明资料。
									</li>
								</ol>

								<ol class="list_text3">
									<p class="qiang_font_p">隐私保护声明</p>
									<li class="lilil">
										<!-- @click="tiaoyemain('privacy')" toprovacy-->
										隐私权保护内容请点击<a @click="tiaoyemain('privacy')" target="_blank" style="color: #315EFB;cursor: pointer;">《隐私保护声明》</a>
									</li>
								</ol>
								
								<ol class="list_text3">
									<p class="qiang_font_p">预测性陈述</p>
									<li class="lilil">
										本网站所发布的信息中可能会包含某些预测性的陈述。这些陈述本质上具有相当风险和不确定性，对本网站所发布的有关中国邮政速递物流股份有限公司及相关业务的预测性陈述，目的均是要指明其属预测性陈述，本公司并不打算不断地更新这些预测性陈述。此等预测性陈述反映本公司对未来事件的目前看法，而并非关于将来业务表现的保证。
									</li>
								</ol>
								
								<ol class="list_text3">
									<p class="qiang_font_p">知识产权</p>
									<li class="lilil">
										本网站所载述的域名商标、文字、视像及声音内容、图形及图象均受有关商标或著作权的法律保护。未经中国邮政速递物流股份有限公司事先以书面明确允许，任何企业或个人不得以任何形式复制或传递 “思乡月”、“代收货款”、等均为中国邮政速递物流股份有限公司所有的注册商标。
									</li>
								</ol>
								
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Page from "@/components/Service/page.vue";
	export default {
		name: "newsandinformation",
		data() {
			return {
				img:require('../../../assets/img/Abouts/he_zuo_zi_xun.png'),
				currentPage3: 1,
				activeName: "first",
				details: [],
				gonggao: [],
				pageNo: "1",
				pageNos: "1",
				PageSize: 10,
				PageSizes: 10,
				totals: 0,
				gonggao_title: 0,
			};
		},
		components: {
			Page,
		},
		methods: {
			
			toprovacy(){
				window.open("/privacy");
			},
			
			tiaoyemain(main) {
				this.$router.push({
					name: main,
				});
			},
			handleClick(tab, event) {
				// console.log(tab);
			},
			// 跳页面
			tiaoyemain(main) {
				this.$router.push({
					name: main,
				});
			},
			// 新闻详情
			toNewsAnd(id) {
				this.$router.push({
					path: "details",
					query: {
						id: id,
						staus: "news",
					},
				});
			},
			// 服务公告
			toAnnounceAnd(id) {
				this.$router.push({
					path: "details",
					query: {
						id: id,
						staus: "announce",
					},
				});
			},
		},
	};
</script>
<style scoped lang="scss">
  @import "../../../assets/css/english-css/Abouts/law.scss"
</style>